import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'
import { useLocation } from 'react-router-dom'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { BulletinViewDataLoader } from '../BulletinView/BulletinViewDataLoader'
import { ErrorHandler } from '../BulletinView/BulletinViewErrorHandler'
import { bulletinBoardLocationStateSchema } from './bulletinBoardLocationState'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { Bulletin } from 'components/Bulletin/Bulletin'

export const BulletinBoardBulletinView: React.FC = () => {
  const { t } = useTranslation(['common', 'titles'])
  const { bulletinBoardPath } = useContractPaths()
  const location = useLocation()
  const validatedState = bulletinBoardLocationStateSchema.safeParse(
    location.state
  )
  const bulletinBoardSearch = validatedState.success
    ? validatedState.data.bulletinBoardSearch
    : undefined

  return (
    <TitleController title={t('titles:bulletin')}>
      <ResidentAppView
        title={t('common:views.bulletin')}
        backLink={
          <ResidentAppBackLink
            href={
              bulletinBoardSearch
                ? `${bulletinBoardPath}?${bulletinBoardSearch}`
                : bulletinBoardPath
            }
          >
            {t('common:views.bulletinBoard')}
          </ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <ErrorHandler>
            <BulletinViewDataLoader>
              {({ bulletin, onLanguageChange }) => (
                <Bulletin
                  bulletin={bulletin}
                  onLanguageChange={onLanguageChange}
                />
              )}
            </BulletinViewDataLoader>
          </ErrorHandler>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
